const results = [
  {
    icon: 'ri-phone-fill',
    title: 'More Inbound Calls',
    desc: 'Your phone rings with people who are already looking for exactly what you offer. No cold outreach, no chasing leads.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Higher Quality Leads',
    desc: 'The people contacting you are ready to buy — not just browsing. Intent-based traffic means better conversations from the start.',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Consistent Customer Flow',
    desc: 'Stop riding the feast-or-famine rollercoaster. Build a steady, reliable stream of new business every single month.',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Clear Return on Investment',
    desc: 'Every dollar tracked. You\'ll know exactly what you\'re spending and what you\'re getting back — no guesswork.',
  },
];

const ResultsSection = () => (
  <section id="results" className="bg-white py-24 md:py-32">
    <div className="max-w-6xl mx-auto px-6 md:px-10">
      <div className="text-center mb-16">
        <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">What You Get</span>
        <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mt-3">Real Business Outcomes</h2>
        <p className="text-gray-500 text-lg mt-4 max-w-xl mx-auto">
          We don't deal in vanity metrics. Everything we do is tied to outcomes that actually move your business forward.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {results.map((r) => (
          <div
            key={r.title}
            className="flex gap-5 items-start bg-[#f8f9fa] rounded-2xl p-7 border-l-4 border-orange-500"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-100 shrink-0">
              <i className={`${r.icon} text-orange-500 text-xl`} />
            </div>
            <div>
              <h3 className="text-gray-900 font-bold text-lg mb-2">{r.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{r.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ResultsSection;
